import styled from "styled-components";

export const Icon = styled.img`
  height: 20px;
  width: 20px;
  object-fit: contain;
  padding: 0 2px;
  margin-right: 4px;
`;
